import { createSelector } from 'reselect';
import _sumBy from 'lodash/sumBy';

import { getShiftDowntimeIntervals } from 'lib/selectors/getShiftDowntimeIntervals';
import { getShiftStart } from 'lib/selectors/getShiftStart';
import { chopBefore } from 'lib/utils/intervals';
import { millis } from 'lib/utils/date';

const getTotalShiftDowntime = createSelector(
  [getShiftDowntimeIntervals, getShiftStart],
  (shiftDowntimeIntervals, shiftStart) => {
    if (
      !shiftDowntimeIntervals ||
      shiftDowntimeIntervals.length <= 0 ||
      !shiftStart
    ) {
      return null;
    }

    // Clip intervals to shift start boundary for duration calculation
    const clippedIntervals = chopBefore(shiftDowntimeIntervals, shiftStart);

    return _sumBy(clippedIntervals, (downtime) => {
      const startMs = millis(downtime.start);
      const endMs = downtime.end ? millis(downtime.end) : millis();
      return Math.round((endMs - startMs) / 1000);
    });
  }
);

export { getTotalShiftDowntime };
